module.exports = __webpack_public_path__ + "c19bcb4d6df9771c01caa4b8ca4e43f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/trash-icon.png
// module id = 133
// module chunks = 0